import React, { useEffect, useState } from 'react'
import { PinListContainer, PinWrapper } from './styles'

interface Props {
  'data-qa'?: string
  length?: number
  initialValue?: string
  onChange: (value: string[]) => void
}

const PinInput: React.FC<any> = (props: Props) => {
  const _storedLength = props.length || 6
  const _initialSetup =
    props.initialValue?.split('') || Array(_storedLength).fill('')
  const dataQa = props['data-qa'] || 'pin-input'

  const [pinList, setPin] = useState<string[]>(_initialSetup)

  useEffect(() => {
    props.onChange(pinList)
  }, [pinList])

  function handleKey(
    keyEvent: React.KeyboardEvent<HTMLInputElement>,
    pinPosition: number,
  ) {
    if (keyEvent.key.length === 1) setPinValue(keyEvent.key, pinPosition)
    switch (keyEvent.key) {
      case 'ArrowLeft':
        selectPin(pinPosition - 1)
        break
      case 'Backspace':
        pinList[pinPosition] === ''
          ? selectPin(pinPosition - 1)
          : setPinValue('', pinPosition)
        break
      case 'Tab':
        if (keyEvent.shiftKey) selectPin(pinPosition - 1)
        break
      default:
        selectPin(pinPosition + 1)
    }
  }

  function onPaste(text: string, fromIndex: number) {
    const slice = text.slice(0, pinList.length - fromIndex)
    let replace = [...pinList]
    slice.split('').map((char, index) => {
      replace[fromIndex + index] = char
      setPin(replace)
    })
    selectPin(fromIndex + (slice.length - 1))
  }

  function setPinValue(key: string, position: number) {
    let replace = [...pinList]
    replace[position] = key
    setPin(replace)
  }

  function selectPin(pinPosition: number) {
    const input: Partial<HTMLInputElement> = document.getElementById(
      `pin-input-${pinPosition}`,
    )
    input?.setSelectionRange(input.value.length, input.value.length)
    input?.focus()
  }

  return (
    <PinListContainer data-qa={dataQa}>
      {pinList.map((pin, index) => (
        <input
          key={index}
          data-qa={`${dataQa}-${index}`}
          title={pin}
          value={pin}
          onChange={() => {}}
          id={`pin-input-${index}`}
          onClick={() => selectPin(index)}
          onKeyUp={(ev) => handleKey(ev, index)}
          onPaste={(ev) => onPaste(ev.clipboardData.getData('Text'), index)}
        />
      ))}
    </PinListContainer>
  )
}

export default PinInput
